import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { glenviewConfig } from "./data";

export default function GlenviewPage() {
  return <CityPageTemplate config={glenviewConfig} />;
}